export default "__VITE_ASSET__25e36951__"